import InputAdornment from '@mui/material/InputAdornment';

export { InputAdornment };
